"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.impossiblePropertyCoverageSchema = void 0;
const zod_1 = require("zod");
const constants_1 = require("../constants");
const PropertyPolicyCoverageTypes_1 = require("../enums/PropertyPolicyCoverageTypes");
const numbers_1 = require("../numbers");
const Coverage_1 = require("./Coverage");
exports.impossiblePropertyCoverageSchema = Coverage_1.impossibleCoverageSchema.extend({
    name: zod_1.z.nativeEnum(PropertyPolicyCoverageTypes_1.PropertyPolicyCoverageTypes),
    rawName: constants_1.defaultString,
    perOccurrenceLimitCents: zod_1.z.nullable(zod_1.z.number().min(1).refine((val) => val <= (0, numbers_1.millionInCents)(20) || val === Coverage_1.UNLIMITED_COVERAGE_LIMIT)),
    perPersonLimitCents: zod_1.z.nullable(zod_1.z.number().min(1).refine((val) => val <= (0, numbers_1.million)(5) || val === Coverage_1.UNLIMITED_COVERAGE_LIMIT)),
    // TODO maxMonthsLimit would be better as literals, but it requires a change to apify-scraper
    // maxMonthsLimit: z.nullable(z.literal(12).or(z.literal(24))),
    maxMonthsLimit: zod_1.z.nullable(zod_1.z.number().refine((num) => num === 12 || num === 24)),
    premiumCents: zod_1.z.nullable(zod_1.z.number().min(0).max((0, numbers_1.million)(4))),
    isDeclined: zod_1.z.nullable(zod_1.z.boolean()),
    deductibleCents: zod_1.z.nullable(zod_1.z.number().min(0).max((0, numbers_1.million)(100))),
    hurricaneDeductibleCents: zod_1.z.nullable(zod_1.z.number().min(0).max((0, numbers_1.million)(100))),
    windstormDeductibleCents: zod_1.z.nullable(zod_1.z.number().min(0).max((0, numbers_1.million)(100))),
    earthquakeDeductibleCents: zod_1.z.nullable(zod_1.z.number().min(0).max((0, numbers_1.million)(100))),
}).strict();
